// Keys used to thread connect-flow state across the OAuth redirect. Same
// pattern as PLAID_OAUTH_AUTH_LOCAL_STORAGE_KEY in src/constants/account-link.
export const MONEYKIT_OAUTH_TOKEN_KEY = 'moneykit_oauth_link_session_token';
export const MONEYKIT_OAUTH_RETURN_PAGE_KEY = 'moneykit_oauth_return_page';
export const MONEYKIT_OAUTH_CLIENT_USER_ID_KEY = 'moneykit_oauth_client_user_id';
export const MONEYKIT_OAUTH_PROVIDER_ACCOUNT_ID_KEY = 'moneykit_oauth_provider_account_id';
export const MONEYKIT_OAUTH_REPLACING_PROVIDER_ACCOUNT_ID_KEY = 'moneykit_oauth_replacing_provider_account_id';
// Stash for the full OAuth redirect href across /login so code/state are not
// copied into /login?returnUrl= (history, logs, Referer).
export const MONEYKIT_OAUTH_RESUME_HREF_KEY = 'moneykit_oauth_resume_href';
export const MONEYKIT_OAUTH_SELECTED_INSTITUTION_NAME_KEY = 'moneykit_oauth_selected_institution_name';

// The Connect SDK writes this key inside startLink / startRelink. continueLink
// reads only this key — not MONEYKIT_OAUTH_TOKEN_KEY.
export const MONEYKIT_SDK_LINK_SESSION_TOKEN_KEY = 'moneykit.linkSessionToken';
